<template>
  <div v-if="toast.visible" class="global-toast" :class="toast.type">
    {{ toast.message }}
  </div>
</template>

<script>
import { toastState } from '@/utils/toast';

export default {
  name: 'GlobalToast',
  computed: {
    toast() {
      return toastState;
    }
  }
};
</script>

<style scoped>
.global-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2147483647;
  max-width: min(520px, calc(100vw - 32px));
  padding: 11px 16px;
  border-radius: 999px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.22);
  animation: toastDropIn 0.22s ease-out;
}

.global-toast.success {
  background: linear-gradient(135deg, #16a34a, #22c55e);
}

.global-toast.error {
  background: linear-gradient(135deg, #dc2626, #f97316);
}

.global-toast.warning {
  background: linear-gradient(135deg, #d97706, #f59e0b);
}

@keyframes toastDropIn {
  from {
    opacity: 0;
    transform: translate(-50%, -10px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
</style>
